import React from 'react'
import CustomerManagerTableItem from "./CustomerManagerTableItem"

function CustomerManagerTableBody(props) {
    const {error, detailListCustomers, arrSelected, onSelected} = props

    return (
        <tbody className="TableBody">
        {
            !!detailListCustomers && detailListCustomers.length > 0 ? detailListCustomers.map((item, index) => (
                <CustomerManagerTableItem
                    key={index} item={item}
                    arrSelected={arrSelected}
                    onSelected={onSelected}
                />
            )) : <tr className="NoRecord">
                <td colSpan={7}>Không có bản ghi nào</td>
            </tr>
        }
        {
            !!error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={7}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default CustomerManagerTableBody
